import request from '@/utils/request';

export const hotModel = () => {
    return request.get('/gem/hot', {
       params: {
            page: 1,
            pageSize: 12,
            userId: 2
        } 
    })
}

export const hotPavilion = () => {
    return request.get('/hall/hot', {
        params: {
            page: 1,
            pageSize: 5,
            userId: 2
        } 
     })
}